<template>
  <div class="card p-4">
    <div class="col-12">
      <button v-if="!isExternalUser" class="btn btn-primary mr-2" @click="openModal('passwordChangeModal')">
        <i class="fa fa-lock pr-2" /> Zmień hasło
      </button>

      <button v-if="!isExternalUser" class="btn btn-danger" @click="openModal('profileDeleteConfirmModal')">
        <i class="fa fa-user-times pr-2" /> Usuń konto
      </button>

      <button class="btn btn-primary float-right" @click="save">
        Zapisz
      </button>

      <hr />
    </div>

    <div style="margin-top: 1em" class="row">
      <div class="form-group col-md-6">
        <w-input :model="$schema.firstName" />
      </div>

      <div class="form-group col-md-6">
        <w-input :model="$schema.lastName" />
      </div>
    </div>

    <div class="form-group">
      <w-input disabled :model="$schema.email" />
    </div>

    <password-change-modal :show="!!modals.passwordChangeModal" @close="closeModal('passwordChangeModal')" />

    <profile-delete-confirm-modal :show="!!modals.profileDeleteConfirmModal" @close="closeDeleteOwnModal" />
  </div>
</template>

<script>
import PasswordChangeModal from '@/components/modals/PasswordChangeModal';
import ProfileDeleteConfirmModal from '@/components/modals/ProfileDeleteConfirmModal';
import { displayModalMixin } from '@/mixins/displayModal';
import { formViewMixin } from '@/mixins/formView';
import { isExternalUser } from '@/mixins/isExternalUser';
import schema from '@/schemas/profile.schema';

const emptyData = () => ({
  email: '',
  firstName: '',
  lastName: '',
  gdprAccepted: true
});

// @vuese
// Edycja profilu
// @group Profile
export default {
  components: { PasswordChangeModal, ProfileDeleteConfirmModal },
  mixins: [
    formViewMixin(
      'profile',
      { updated: 'Zaktualizowano dane profilu.', updateError: 'Nie udało się zaktualizować danych profilu.' },
      emptyData
    ),
    displayModalMixin,
    isExternalUser
  ],
  schema,
  methods: {
    // @vuese
    // Zamknięcie modala usuwania konta
    closeDeleteOwnModal(success) {
      this.closeModal('profileDeleteConfirmModal');
      if (success) {
        this.prompt();
      }
    },
    // @vuese
    // Powiadomienie o wysłaniu maila
    prompt() {
      this.$store.commit('showConfirm', {
        title: 'Uwaga',
        description: 'Na Twój adres mailowy przypisany do konta został wysłany link, który umożliwi usunięcie konta.',
        submitButton: 'Ok',
        showCloseButton: false,
        onSuccess: () => {}
      });
    }
  }
};
</script>
